/**
 * Metadatos de estado de las pantallas DOOH (US 2.6).
 *
 * Mismo contrato que el semáforo del NOC: cada estado expone etiqueta + color +
 * `colorDark` + `iconKey`, para que la UI renderice **color + icono + texto** (nunca
 * solo color, WCAG 2.2 AA). El semáforo de pantalla se alinea con la operación:
 * verde (en línea) / rojo (sin contacto) / amarillo (desconocido).
 */
import type { DoohScreenStatus } from '@goelectric/shared-types';
import type { StatusMeta } from '@goelectric/ui-components';
import { darkColors, neutralColors, semanticColors } from '@goelectric/ui-components';

export const DOOH_SCREEN_STATUS_META: Record<DoohScreenStatus, StatusMeta> = {
  ONLINE: {
    label: 'En línea',
    description: 'La pantalla reportó contacto recientemente.',
    color: semanticColors.success,
    colorDark: darkColors.success,
    iconKey: 'check',
  },
  OFFLINE: {
    label: 'Sin conexión',
    description: 'La pantalla dejó de reportar contacto.',
    color: semanticColors.danger,
    colorDark: darkColors.danger,
    iconKey: 'offline',
  },
  UNKNOWN: {
    label: 'Desconocido',
    description: 'La pantalla aún no ha reportado contacto.',
    color: semanticColors.warning,
    colorDark: darkColors.warning,
    iconKey: 'info',
  },
};

/** Color de texto secundario reutilizable para metadatos (coherente con la guía). */
export const DOOH_MUTED_COLOR = neutralColors.textMuted;
